document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.mega_product_block_content').forEach(function(collcard) {
    const swiperEl = collcard.querySelector('.product_block_slider_swiper');
    if (!swiperEl) return;
    const prevBtn = collcard.querySelector('.product_block_slider_swiper_button_prev');
    const nextBtn = collcard.querySelector('.product_block_slider_swiper_button_next');
    const swiper = new Swiper(swiperEl, {
      slidesPerView: 'auto',
      spaceBetween: 10,
      loop: false,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
      on: {
        init: function () {
            checkScrollable(this);
        },
        resize: function () {
            checkScrollable(this);
        },
     },
    });

    function checkScrollable(swiperInstance) {
        const mainwrapp = collcard.querySelector('.product_block_slider_content');
        const wrapper = swiperInstance.wrapperEl;
        const container = swiperInstance.el;

        if (wrapper.scrollWidth > container.clientWidth) {
            mainwrapp.classList.add("product_block_slider_scrollable");
            mainwrapp.classList.remove("product_block_slider_not_scrollable");
        } else {
            mainwrapp.classList.remove("product_block_slider_scrollable");
            mainwrapp.classList.add("product_block_slider_not_scrollable");
        }
    }

  });
  
});


document.addEventListener("DOMContentLoaded", () => {
  const items = document.querySelectorAll(".mega_categories_block_menu .mega_categories_block_list .mega_categories_block_item");

  // if no items found, stop
  if (!items.length) return;

  items.forEach(item => {
    const title = item.querySelector(".mega_categories_block_title");
    const content = item.querySelector(".mega_categories_block_content");
    if (!title || !content) return; // skip if missing

    title.addEventListener("click", () => {
      // remove active from all
      items.forEach(i => {
        const t = i.querySelector(".mega_categories_block_title");
        const c = i.querySelector(".mega_categories_block_content");
        if (t) t.classList.remove("active");
        if (c) c.classList.remove("active");
      });

      // add active only to clicked one
      title.classList.add("active");
      content.classList.add("active");
    });
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const ditems = document.querySelectorAll(
    ".mega_categories_block_menu_drawer .mega_categories_block_list .mega_categories_block_item"
  );

  if (!ditems.length) return;

  ditems.forEach(item => {
    const title = item.querySelector(".mega_categories_block_title");
    const content = item.querySelector(".mega_categories_block_content");
    if (!title || !content) return;

    // prepare styles
    content.style.overflow = "hidden";
    content.style.transition = "height 0.3s ease";

    // if already active at page load → expand it
    if (title.classList.contains("active") && content.classList.contains("active")) {
      content.style.height = content.scrollHeight + "px";
    } else {
      content.style.height = "0px";
    }

    title.addEventListener("click", () => {
      const isOpen = content.classList.contains("active");

      // close all first
      ditems.forEach(i => {
        const t = i.querySelector(".mega_categories_block_title");
        const c = i.querySelector(".mega_categories_block_content");
        if (!t || !c) return;
        t.classList.remove("active");
        c.classList.remove("active");
        c.style.height = "0px";
      });

      // if it was not open → open it
      if (!isOpen) {
        title.classList.add("active");
        content.classList.add("active");
        content.style.height = content.scrollHeight + "px";
      }
    });
  });
});


